import { adminEndpoints } from "../apis";

import { toast } from "react-hot-toast";

import { apiConnector } from "../apiconnector";

const {
  SHOW_ALL_CATEGORIES,
  GET_CATEGORY_PAGE_DETAILS,
  GET_ALL_INSTRUCTOR_DETAILS,
  GET_ALL_STUDENT_DETAILS,
  GET_ALL_COURSE,
  CREATE_CATEGORY_API,
  UPDATE_CATEGORY_API,
  DELETE_CATEGORY_API,
  GET_ALL_CATEGORIES_API,
} = adminEndpoints;

export const getAllCategoryPageDetails = async () => {
  const toastId = toast.loading("Loading...");
  let result = [];
  try {
    const response = await apiConnector("GET", GET_CATEGORY_PAGE_DETAILS);
    if (!response?.data?.success) {
      throw new Error("Could Not Fetch Course Categories");
    }
    result = response?.data?.data;
  } catch (error) {
    console.log("GET_CATEGORY_PAGE_DETAILS API ERROR............", error);
    toast.error(error.message);
  }
  toast.dismiss(toastId);
  return result;
};

export const getAllInstructorDetails = async () => {
  const toastId = toast.loading("Loading...");
  let result = [];
  try {
    const response = await apiConnector("GET", GET_ALL_INSTRUCTOR_DETAILS);
    if (!response?.data?.success) {
      throw new Error("Could Not Fetch Course Categories");
    }
    result = response?.data?.data;
  } catch (error) {
    console.log("GET_ALL_INSTRUCTOR_DETAILS API ERROR............", error);
    toast.error(error.message);
  }
  toast.dismiss(toastId);
  return result;
};

export const getAllStudentDetails = async () => {
  const toastId = toast.loading("Loading...");
  let result = [];
  try {
    const response = await apiConnector("GET", GET_ALL_STUDENT_DETAILS);
    if (!response?.data?.success) {
      throw new Error("Could Not Fetch Course Categories");
    }
    result = response?.data?.data;
  } catch (error) {
    console.log("GET_ALL_STUDENT_DETAILS API ERROR............", error);
    toast.error(error.message);
  }
  toast.dismiss(toastId);
  return result;
};

export const getAllCourses = async () => {
  const toastId = toast.loading("Loading...");
  let result = [];
  try {
    const response = await apiConnector("GET", GET_ALL_COURSE);
    if (!response?.data?.success) {
      throw new Error("Could Not Fetch Course Categories");
    }
    result = response?.data?.data;
  } catch (error) {
    console.log("GET_ALL_COURSE API ERROR............", error);
    toast.error(error.message);
  }
  toast.dismiss(toastId);
  return result;
};

export const getAllCategories = async () => {
  const toastId = toast.loading("Loading...");
  let result = [];
  try {
    const response = await apiConnector("GET", SHOW_ALL_CATEGORIES);
    if (!response?.data?.success) {
      throw new Error("Could Not Fetch Course Categories");
    }
    result = response?.data?.data;
  } catch (error) {
    console.log("SHOW_ALL_CATEGORIES API ERROR............", error);
    toast.error(error.message);
  }
  toast.dismiss(toastId);
  return result;
};

export const getAdminCategories = async (token) => {
  let result = [];
  try {
    const response = await apiConnector("GET", GET_ALL_CATEGORIES_API, null, {
      Authorization: `Bearer ${token}`,
    });
    if (!response?.data?.success) throw new Error("Could not fetch categories");
    result = response?.data?.data;
  } catch (error) {
    console.log("GET_ALL_CATEGORIES API ERROR:", error);
    toast.error(error.message);
  }
  return result;
};

export const updateCategory = async (data, token) => {
  const toastId = toast.loading("Updating category...");
  let result = null;
  try {
    const response = await apiConnector("PUT", UPDATE_CATEGORY_API, data, {
      Authorization: `Bearer ${token}`,
    });
    if (!response?.data?.success) throw new Error(response?.data?.message || "Failed to update category");
    toast.success("Category updated successfully");
    result = response.data.data;
  } catch (error) {
    console.log("UPDATE_CATEGORY API ERROR:", error);
    toast.error(error.message);
  }
  toast.dismiss(toastId);
  return result;
};

export const deleteCategory = async (categoryId, token) => {
  const toastId = toast.loading("Deleting category...");
  let success = false;
  try {
    const response = await apiConnector("DELETE", DELETE_CATEGORY_API, { categoryId }, {
      Authorization: `Bearer ${token}`,
    });
    if (!response?.data?.success) throw new Error(response?.data?.message || "Failed to delete category");
    toast.success("Category deleted");
    success = true;
  } catch (error) {
    console.log("DELETE_CATEGORY API ERROR:", error);
    toast.error(error.message);
  }
  toast.dismiss(toastId);
  return success;
};

export const createCategory = async (data, token) => {
  const toastId = toast.loading("Creating category...");
  let success = false;
  try {
    const response = await apiConnector("POST", CREATE_CATEGORY_API, data, {
      Authorization: `Bearer ${token}`,
    });
    if (!response?.data?.success) {
      throw new Error(response?.data?.message || "Failed to create category");
    }
    toast.success("Category created successfully");
    success = true;
  } catch (error) {
    console.log("CREATE_CATEGORY API ERROR:", error);
    toast.error(error.message);
  }
  toast.dismiss(toastId);
  return success;
};
